(() => {
  const parseVideoUrl = (url) => {
    if (!url) return { provider: 'none', id: '' };
    const value = url.trim();
    if (!value) return { provider: 'none', id: '' };
    if (value.includes('youtu.be/')) return { provider: 'youtube', id: value.split('youtu.be/')[1].split(/[?&#]/)[0] };
    if (value.includes('youtube.com/watch')) {
      try {
        const parsed = new URL(value);
        return { provider: 'youtube', id: parsed.searchParams.get('v') || '' };
      } catch (error) {
        return { provider: 'youtube', id: '' };
      }
    }
    if (value.includes('youtube.com/embed/')) return { provider: 'youtube', id: value.split('embed/')[1].split(/[?&#]/)[0] };
    if (value.includes('vimeo.com/')) {
      const match = value.match(/vimeo\.com\/(?:video\/)?([0-9]+)/);
      return { provider: 'vimeo', id: match ? match[1] : '' };
    }
    return { provider: 'file', id: value };
  };

  const setReviewExpanded = (card, expanded) => {
    if (!card) return;
    card.classList.toggle('is-review-expanded', expanded);
    const button = card.querySelector('[data-review-toggle]');
    const label = button ? button.querySelector('[data-review-toggle-label]') : null;
    if (button) button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    if (label) label.textContent = expanded ? 'Less' : 'More';
  };

  const mountVideo = (trigger) => {
    if (!trigger || trigger.dataset.loaded === 'true') return;
    const shell = trigger.closest('[data-video-shell]');
    if (!shell) return;
    const card = shell.closest('[data-testimonial-card]');
    const explicitProvider = trigger.dataset.videoProvider || 'none';
    const url = trigger.dataset.videoUrl || '';
    let replacement = null;

    if (explicitProvider === 'shopify') {
      const template = shell.querySelector('[data-shopify-video-template]');
      if (template) replacement = template.content.firstElementChild.cloneNode(true);
    } else {
      const parsed = parseVideoUrl(url);
      if (parsed.provider === 'youtube' && parsed.id) {
        replacement = document.createElement('iframe');
        replacement.src = `https://www.youtube.com/embed/${parsed.id}?autoplay=1&rel=0`;
        replacement.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
        replacement.allowFullscreen = true;
        replacement.className = 'page-testimonials__video-embed';
        replacement.loading = 'lazy';
        replacement.title = 'Customer testimonial video';
      } else if (parsed.provider === 'vimeo' && parsed.id) {
        replacement = document.createElement('iframe');
        replacement.src = `https://player.vimeo.com/video/${parsed.id}?autoplay=1&title=0&byline=0&portrait=0`;
        replacement.allow = 'autoplay; fullscreen; picture-in-picture';
        replacement.allowFullscreen = true;
        replacement.className = 'page-testimonials__video-embed';
        replacement.loading = 'lazy';
        replacement.title = 'Customer testimonial video';
      } else if (parsed.provider === 'file' && parsed.id) {
        replacement = document.createElement('video');
        replacement.src = parsed.id;
        replacement.controls = true;
        replacement.autoplay = true;
        replacement.playsInline = true;
        replacement.preload = 'metadata';
        replacement.className = 'page-testimonials__video-player';
      }
    }

    if (!replacement) return;

    setReviewExpanded(card, false);
    if (card) card.classList.add('is-playing');

    shell.innerHTML = '';
    shell.appendChild(replacement);
    trigger.dataset.loaded = 'true';

    if (replacement.tagName === 'VIDEO') {
      replacement.addEventListener('ended', () => {
        if (card) card.classList.remove('is-playing');
      });
      replacement.play().catch(() => {});
    }
  };


  document.querySelectorAll('[data-testimonials-page]').forEach((section) => {
    const cards = Array.from(section.querySelectorAll('[data-testimonial-card]'));
    const grid = section.querySelector('[data-testimonials-grid]');
    const count = section.querySelector('[data-results-count]');
    const empty = section.querySelector('[data-empty-state]');
    const clearButton = section.querySelector('[data-clear-filters]');
    const drawer = section.querySelector('[data-filter-drawer]');
    const openButton = section.querySelector('[data-filter-open]');
    const layoutToggle = section.querySelector('[data-layout-toggle]');
    const closeButtons = Array.from(section.querySelectorAll('[data-filter-close]'));
    const panelButtons = Array.from(section.querySelectorAll('[data-filter-panel-button]'));
    const panels = Array.from(section.querySelectorAll('[data-filter-panel]'));
    const filterButtons = Array.from(section.querySelectorAll('[data-filter-group][data-filter-value]'));
    const total = cards.length;
    const state = {
      conditions: new Set(['all']),
      result: 'all',
      rating: 'all',
      gender: 'all',
      age: 'all',
      duration: 'all'
    };

    if (layoutToggle && grid) {
      layoutToggle.addEventListener('click', () => {
        const current = grid.dataset.gridLayout || '1x1';
        const next = current === '1x1' ? '2x2' : '1x1';
        grid.dataset.gridLayout = next;
        grid.classList.toggle('page-testimonials__grid--2x2', next === '2x2');
        cards.forEach((card) => setReviewExpanded(card, false));
        const icon2x2 = layoutToggle.querySelector('.page-testimonials__layout-icon--2x2');
        const icon4x4 = layoutToggle.querySelector('.page-testimonials__layout-icon--4x4');
        const iconSingle = layoutToggle.querySelector('.page-testimonials__layout-icon--single');
        const isMobile = window.innerWidth < 750;
        
        if (next === '1x1') {
          if (isMobile) {
            icon2x2.style.display = 'block';
          } else {
            icon4x4.style.display = 'block';
          }
          iconSingle.style.display = 'none';
        } else {
          icon2x2.style.display = 'none';
          icon4x4.style.display = 'none';
          iconSingle.style.display = 'block';
        }
      });
    }

    section.querySelectorAll('[data-video-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', () => mountVideo(trigger));
    });

    section.querySelectorAll('[data-review-toggle]').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const card = button.closest('[data-testimonial-card]');
        if (!card || card.classList.contains('is-playing')) return;
        const expanded = !card.classList.contains('is-review-expanded');
        cards.forEach((otherCard) => {
          if (otherCard !== card) setReviewExpanded(otherCard, false);
        });
        setReviewExpanded(card, expanded);
      });
    });

    const switchPanel = (panelName) => {
      panelButtons.forEach((button) => {
        const active = button.dataset.panel === panelName;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      panels.forEach((panel) => {
        const active = panel.dataset.filterPanel === panelName;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    };

    const openDrawer = () => {
      if (!drawer) return;
      drawer.hidden = false;
      if (openButton) openButton.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    };

    const closeDrawer = () => {
      if (!drawer) return;
      drawer.hidden = true;
      if (openButton) openButton.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    };

    const updateButtons = (group) => {
      section.querySelectorAll(`[data-filter-group="${group}"]`).forEach((button) => {
        const value = button.dataset.filterValue || 'all';
        const active = group === 'conditions' ? state.conditions.has(value) : state[group] === value;
        button.classList.toggle('active', active);
      });
    };

    const applyFilters = () => {
      const conditionFilters = Array.from(state.conditions).filter((value) => value !== 'all');
      let visible = 0;

      cards.forEach((card) => {
        const tags = (card.dataset.tags || '').split(/\s+/).filter(Boolean);
        const conditionsMatch = conditionFilters.length === 0 || conditionFilters.some((filter) => tags.includes(filter));
        const resultMatch = state.result === 'all' || (card.dataset.result || '') === state.result;
        const ratingMatch = state.rating === 'all' || Number(card.dataset.rating || '0') >= Number(state.rating);
        const genderMatch = state.gender === 'all' || (card.dataset.gender || '') === state.gender;
        const ageMatch = state.age === 'all' || (card.dataset.age || '') === state.age;
        const durationMatch = state.duration === 'all' || (card.dataset.duration || '') === state.duration;
        const show = conditionsMatch && resultMatch && ratingMatch && genderMatch && ageMatch && durationMatch;
        card.hidden = !show;
        if (show) visible += 1;
      });

      if (count) count.textContent = `Showing ${visible} of ${total} reviews`;
      if (empty) empty.hidden = visible !== 0;
      if (clearButton) {
        const hasConditions = conditionFilters.length > 0;
        const hasOther = ['result', 'rating', 'gender', 'age', 'duration'].some((key) => state[key] !== 'all');
        clearButton.hidden = !(hasConditions || hasOther);
      }
      if (grid) grid.style.display = visible === 0 ? 'none' : 'grid';

      syncResultTags(conditionFilters);
    };

    const syncResultTags = (activeFilters) => {
      cards.forEach((card) => {
        if (card.hidden) return;
        const resultTag = card.querySelector('[data-result-tag]');
        if (!resultTag) return;

        const cardTags = (card.dataset.tags || '').split(/\s+/).filter(Boolean);
        if (activeFilters.length > 0) {
          const matchedFilter = activeFilters.find((filter) => cardTags.includes(filter));
          if (matchedFilter) {
            const filterButton = section.querySelector(`[data-filter-group="conditions"][data-filter-value="${matchedFilter}"]`);
            if (filterButton) {
              resultTag.textContent = filterButton.textContent;
              resultTag.style.display = '';
            }
          } else {
            resultTag.style.display = 'none';
          }
        } else {
          resultTag.style.display = '';
        }
      });
    };

    filterButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const group = button.dataset.filterGroup;
        const value = button.dataset.filterValue || 'all';
        if (!group) return;

        if (group === 'conditions') {
          if (value === 'all') {
            state.conditions.clear();
            state.conditions.add('all');
          } else {
            state.conditions.delete('all');
            if (state.conditions.has(value)) {
              state.conditions.delete(value);
            } else {
              state.conditions.add(value);
            }
            if (state.conditions.size === 0) state.conditions.add('all');
          }
        } else {
          state[group] = value;
        }

        updateButtons(group);
        applyFilters();
      });
    });

    if (clearButton) {
      clearButton.addEventListener('click', () => {
        state.conditions = new Set(['all']);
        state.result = 'all';
        state.rating = 'all';
        state.gender = 'all';
        state.age = 'all';
        state.duration = 'all';
        ['conditions', 'result', 'rating', 'gender', 'age', 'duration'].forEach(updateButtons);
        applyFilters();
      });
    }

    if (openButton) openButton.addEventListener('click', openDrawer);
    closeButtons.forEach((button) => button.addEventListener('click', closeDrawer));
    panelButtons.forEach((button) => {
      button.addEventListener('click', () => switchPanel(button.dataset.panel));
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      if (drawer && !drawer.hidden) closeDrawer();
      cards.forEach((card) => setReviewExpanded(card, false));
    });

    if (panelButtons[0]) switchPanel(panelButtons[0].dataset.panel);
    ['conditions', 'result', 'rating', 'gender', 'age', 'duration'].forEach((group) => {
      if (section.querySelector(`[data-filter-group="${group}"]`)) updateButtons(group);
    });
    applyFilters();

    const originalCta = section.querySelector('[data-cta-original]');
    const stickyCta = document.getElementById('page-testimonials-sticky-cta');
    let stickyVisible = false;

    if (originalCta && stickyCta) {
      const handleStickyScroll = () => {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const windowHeight = window.innerHeight;
        const docHeight = document.documentElement.scrollHeight;
        const originalCtaRect = originalCta.getBoundingClientRect();
        const originalCtaBottom = originalCtaRect.bottom;
        const visibleCount = Array.from(cards).filter((card) => !card.hidden).length;
        const gridLayout = grid ? grid.dataset.gridLayout : '1x1';
        const rowsToShow = gridLayout === '2x2' ? Math.ceil(visibleCount / 2) : visibleCount;
        const nearPageEnd = scrollTop + windowHeight >= docHeight - 100;
        const originalCtaVisible = originalCtaBottom > 0 && originalCtaBottom <= windowHeight;
        const scrollThreshold = gridLayout === '2x2' ? 100 : 500;

        if (scrollTop > scrollThreshold && rowsToShow >= 3 && !originalCtaVisible && !nearPageEnd) {
          if (!stickyVisible) {
            stickyCta.classList.add('sticky-testimonials-cta--visible');
            section.classList.add('has-sticky-testimonials-cta');
            stickyVisible = true;
          }
        } else {
          if (stickyVisible) {
            stickyCta.classList.remove('sticky-testimonials-cta--visible');
            section.classList.remove('has-sticky-testimonials-cta');
            stickyVisible = false;
          }
        }
      };

      window.addEventListener('scroll', handleStickyScroll, { passive: true });
      handleStickyScroll();
    }
  });
})();